<template>
  <div>
    <el-dialog
      title="定位设置"
      :visible.sync="mapVisible"
      left
      :append-to-body="true"
      :lock-scroll="false"
      width="65%"
      :show-close="false"
    >
      <div class="map">
        <div
          id="container"
          style="height: 70vh; width: 100%"
          ref="allmap"
        ></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          size="small"
          icon="el-icon-close"
          @click.native="close"
          >取消</el-button
        >
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-check"
          @click.native="findlocation"
          >保存</el-button
        > -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
var map;
let geoc = null;
import { MP } from "@/utils/map.js";

export default {
  props: {
    mapVisible: "",
  },
  data() {
    return {
      // mapVisible:false,
      dialogMap: false,
      mapPointName: "",
      mapGetshow: true,
    };
  },
  mounted() {},
  created() {},
  methods: {
    close() {
      this.$emit("mapLocationClose");
    },
    Echo(adress) {
      this.loading = true;
      this.adress=adress
      // setTimeout(() => {
      //   this.mapNameChange(adress); //调用定位地点的方法

      // }, 1000);
      this.$nextTick(function () {
      var _this = this;
      MP(_this.ak).then((BMap) => {
        let that = this;
        this.dialogMap = !this.dialogMap;
        if (that.mapGetshow) {
          map = new BMap.Map("container"); //存放地图容器的id
          geoc = new BMap.Geocoder();
          map.enableScrollWheelZoom();
        }
        _this.mapNameChange(adress) 
      });
    });
    },
    mapNameChange(adress) {
      let that = this,
        point,
        marker = null;
      let local = new BMap.LocalSearch(map, {
        renderOptions: { map: map },
        onSearchComplete: (res) => {
          if (local.getResults() != undefined) {
            map.clearOverlays(); //清除地图上所有覆盖物
            if (local.getResults().getPoi(0)) {
              point = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
              map.centerAndZoom(point, 10);
              marker = new BMap.Marker(point); // 创建标注
              map.addOverlay(marker); // 将标注添加到地图中
              marker.enableDragging(); // 可拖拽
              geoc.getLocation(point, function (rs) {
                var addComp = rs.addressComponents;
                that.mapPointName =
                  addComp.province +
                  ", " +
                  addComp.city +
                  ", " +
                  addComp.district +
                  ", " +
                  addComp.street +
                  ", " +
                  addComp.streetNumber;
              });
            } else {
              console.log("未搜索到结果");
            }
          } else {
            alert("未搜索到结果");
          }
        },
      });
      local.search(adress); //要展示的地点
    },
  },
  mounted() {
    
  },
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.map {
  margin-top: 5px;
}
.demo-input-suffix {
  width: 100%;
  margin-top: 40px;
}
.BMap_bubble_title a {
  /* 隐藏搜索结果的详情按钮 */
  display: none;
}
.anchorBL {
  display: none;
} /* 去除百度地图左下角的介绍文字 */
</style>